import { render } from "./ReceiptView.vue?vue&type=template&id=98e8206c&scoped=true"
import script from "./ReceiptView.vue?vue&type=script&lang=js"
export * from "./ReceiptView.vue?vue&type=script&lang=js"

import "./ReceiptView.vue?vue&type=style&index=0&id=98e8206c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e8206c"]])

export default __exports__